import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { loadState } from '../../../utils/local-storage';
import { isUserAllowed } from '../../../utils/tab-permissions';
import { StoreSelect } from '../../reusable';

import ProductTab from './ProductTab';
import PromotionTab from './PromotionTab';
import ReportsTab from './ReportsTab';
import TaxTab from './TaxTab';

import './store-data-validation.css';

const scsKeyGroups = [
  'SCS.ALL', 'SCS.ALL.ReadOnly', 'SCS.ASSIST', 'SCS.ASSIST.ReadOnly',
  'SCS.LINK', 'SCS.LINK.ReadOnly', 'SCS.NPOS', 'SCS.NPOS.ReadOnly',
  'SCS.OTHER', 'SCS.OTHER.ReadOnly', 'SCS.POS', 'SCS.POS.ReadOnly',
  'SCS.PROMOTE', 'SCS.PROMOTE.ReadOnly', 'SCS.RL', 'SCS.RL.ReadOnly',
  'SCS.RISE', 'SCS.RISE.ReadOnly', 'SCS.SFS', 'SCS.SFS.ReadOnly',
  'SCS.SIM', 'SCS.SIM.ReadOnly', 'SCS.SCO', 'SCS.SCO.ReadOnly',
  'SCS.TRACK', 'SCS.TRACK.ReadOnly',
];

const storeviewsFields = ['address.country', 'brand', 'id', 'storeNumber', 'region'];

class StoreDataValidationMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scsGroups: [],
      selectedCountry: loadState('auth')?.country,
      selectedStore: null,
    };
  }

  componentDidMount() {
    const userScsGroups = scsKeyGroups.filter(
      (group) => isUserAllowed(this.props.userInfo.groups, group),
    );
    this.setState({ scsGroups: userScsGroups });
  }

  selectCountry = (selectedCountry) => {
    this.setState({
      selectedCountry,
      selectedStore: null,
    });
  };

  selectStore = (selectedStore) => {
    this.setState({ selectedStore });
  };

  render() {
    const { scsGroups, selectedCountry, selectedStore } = this.state;
    const { userInfo } = this.props;

    if (scsGroups.length === 0) {
      return (
        <main className="ncss-col-sm-10">
          <p>You do not have permission to access Store Data Validation.</p>
        </main>
      );
    }

    const showTabs = Boolean(selectedCountry) && Boolean(selectedStore);

    return (
      <main className="ncss-col-sm-10 sdv-page">
        <StoreSelect
          selectCountry={this.selectCountry}
          selectStore={this.selectStore}
          selectedCountry={selectedCountry}
          selectedStore={selectedStore}
          storeviewsFields={storeviewsFields}
        />

        {showTabs && (
          <section className="sdv-cards">
            <ProductTab
              accessToken={userInfo.accessToken}
              selectedStore={selectedStore}
            />
            <TaxTab
              accessToken={userInfo.accessToken}
              selectedStore={selectedStore}
            />
            <PromotionTab
              accessToken={userInfo.accessToken}
              selectedStore={selectedStore}
            />
            <ReportsTab
              accessToken={userInfo.accessToken}
              selectedCountry={selectedCountry}
              selectedStore={selectedStore}
            />
          </section>
        )}
      </main>
    );
  }
}

StoreDataValidationMain.propTypes = {
  userInfo: PropTypes.shape({
    accessToken: PropTypes.string,
    email: PropTypes.string,
    groups: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

const mapStateToProps = (state) => ({
  userInfo: state.authorizationReducer.auth,
});

export default connect(mapStateToProps, null)(StoreDataValidationMain);
